import { configureStore } from '@reduxjs/toolkit'
import { load, save } from 'redux-localstorage-simple'
import auth from './auth'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { api } from 'services/baseApi'
import { authApi } from 'services/auth'
import { authzApi } from 'services/authz'

const PERSISTED_KEYS: string[] = ['auth']

const store = configureStore({
  reducer: {
    auth,
    [api.reducerPath]: api.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [authzApi.reducerPath]: authzApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
    })
      .concat(api.middleware)
      .concat(save({ states: PERSISTED_KEYS })),
  preloadedState: load({ states: PERSISTED_KEYS }),
})

setupListeners(store.dispatch)

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
